// extracted by mini-css-extract-plugin
export default {"orgDetailsBox":"organisationDetails_orgDetailsBox__VuYlN","orgDetailsForm":"organisationDetails_orgDetailsForm__IHqFt"};